import React from 'react';
import templateRu from 'legal-texts/texts/agreement-ru.html';
import templateEn from 'legal-texts/texts/agreement-en.html';

import './LegalTexts.css';

import replace from './../lib/legal-texts-replace';

export default function(props: { lng: string }) {
  return (
    <div
      className="legal-text"
      dangerouslySetInnerHTML={{
        __html:
          props.lng === 'en'
            ? replace(templateEn, props.lng)
            : replace(templateRu, props.lng)
      }}
    ></div>
  );
}
